var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.98 4.22l-14.392 14.392c-0.188 0.127-0.42 0.203-0.669 0.203s-0.481-0.076-0.673-0.205l0.004 0.003-14.297-14.297c-0.245 0.37-0.391 0.824-0.391 1.312 0 0 0 0.001 0 0.001v-0 20.744c0 1.332 1.080 2.412 2.412 2.412v0h26.050c1.332 0 2.412-1.080 2.412-2.412v0-20.744c0 0 0 0 0 0 0-0.529-0.171-1.019-0.461-1.415l0.005 0.007z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.077 15.254c0.217 0.213 0.514 0.344 0.843 0.344s0.626-0.131 0.843-0.344l-0 0 12.038-12.038h-25.761l12.018 12.018z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.db07b6ec91b1f68dfc6b507a8cdc114d.svg";
export { ForwardRef as ReactComponent };